export default function Footer() {
	return <footer>&copy; Veniway {new Date().getFullYear()}</footer>;
}
